module.exports = __webpack_public_path__ + "img/DIHS_Logo_pos_rgb_800px.026e178e.png";